export function setCachesearchesLoading (state, loading = false) {
  state.cachesearchesLoading = loading
}

export function setCachesearches (state, cachesearches) {
  if (cachesearches && cachesearches.data) {
    state.cachesearches = cachesearches.data
    state.cachesearchesCurrentPage = cachesearches.current_page
    state.cachesearchesLastPage = cachesearches.last_page
    state.cachesearchesPerPage = cachesearches.per_page
    state.cachesearchesTotal = cachesearches.total
  } else if (cachesearches && Array.isArray(cachesearches)) {
    state.cachesearches = cachesearches
    state.cachesearchesCurrentPage = 1
    state.cachesearchesLastPage = 1
    state.cachesearchesPerPage = 100
    state.cachesearchesTotal = cachesearches.length
  }
}

export function setIndexPage (state, page = null) {
  state.indexPage = page
}
